import React from 'react';
import { contains, isEmpty, logger } from 'util/index';

import withGraphqlData from 'components/hoc/withGraphqlData';

import AccordionList from 'components/AccordionList';
import Banner from 'components/Banner';
import MopinionForm from 'components/MopinionForm';
import Teaser from 'components/Teaser';

import CallToActionBlock from 'components/CallToActionBlock';
import CardDeck from 'components/CardDeck';
import Composite from 'components/Composite';
import FeaturedPodcasts from 'components/FeaturedPodcasts';
import IFrame from 'components/IFrame';
import Image from 'components/Image';
import OnDemandCollection from 'components/OnDemandSection';
import Quote from 'components/Quote';
import RecentlyPlayedStationsCollection from 'components/RecentlyPlayedStationsCollection';
import RichText from 'components/RichText';
import Tabs from 'components/Tabs';
import TextFrame from 'components/TextFrame';
import Video from 'components/Video';
import Overview from 'components/Overview';
import Collection from 'components/Collection';
import CONTENT_TYPE_ID from 'globalConst/contentTypes-const';

import { TILE_COMPONENT_TYPES } from '../TileComponent/TileComponent.const';
import withPlayouts from '../hoc/withPlayouts';

type ContentTypeComponent = {
  slug?: string;
  contentTypeId: string;
  items?: Array<unknown>;
};

const ContentTypeComponent = (props: ContentTypeComponent): JSX.Element => {
  const { contentTypeId } = props;
  const COLLECTION_CONTENT_TYPES = {
    stationCollection: TILE_COMPONENT_TYPES.STATION,
    genreCollection: TILE_COMPONENT_TYPES.TAG,
    moodCollection: TILE_COMPONENT_TYPES.TAG,
    tagCollection: TILE_COMPONENT_TYPES.TAG,
    showCollection: TILE_COMPONENT_TYPES.SHOW,
    promotionCollection: TILE_COMPONENT_TYPES.PROMOTION,
    onDemandCollection: TILE_COMPONENT_TYPES.ON_DEMAND,
    podcastCollection: TILE_COMPONENT_TYPES.PODCAST,
    recentlyPlayedStationsCollection: TILE_COMPONENT_TYPES.RECENTLY_PLAYED_STATION,
    mixedCollection: TILE_COMPONENT_TYPES.MIXED_CONTENT,
  };

  // Check if collection components exists
  let tileComponent = null;
  if (contains(contentTypeId, 'collection')) {
    if (!contains(Object.keys(COLLECTION_CONTENT_TYPES), contentTypeId) && contentTypeId !== 'overviewCollection') {
      logger.warn(`The dynamic component ${contentTypeId} could not be rendered.`);
      return null;
    }
    tileComponent = COLLECTION_CONTENT_TYPES[contentTypeId];
  }

  const CONTENT_TYPES = {
    //TODO: Remove?
    banner: Banner,

    //TODO: Remove?
    cardDeck: CardDeck,

    accordionList: AccordionList,
    callToActionBlock: CallToActionBlock,
    composite: Composite,
    featuredPodcasts: FeaturedPodcasts,
    iFrame: IFrame,
    image: Image,
    tagCollection: Collection,
    genreCollection: Collection,
    moodCollection: Collection,
    mopinionForm: MopinionForm,
    onDemandCollection: OnDemandCollection,
    podcastCollection: Collection,
    quote: Quote,
    richText: RichText,
    showCollection: Collection,
    stationCollection: withPlayouts(Collection),
    recentlyPlayedStationsCollection: RecentlyPlayedStationsCollection,
    tabs: Tabs,
    teaser: Teaser,
    textFrame: TextFrame,
    video: Video,
    promotionCollection: Collection,
    mixedCollection: Collection,
    // overview: disableLazyFetch ? Overview : withGraphQL(Overview),
    // overviewCollection: disableLazyFetch ? Overview : withGraphQL(Overview),
    overview: Overview,
    overviewCollection: Overview,
  };

  let Component = CONTENT_TYPES[contentTypeId];
  const storeData = contains([CONTENT_TYPE_ID.OVERVIEW_COLLECTION, CONTENT_TYPE_ID.OVERVIEW], contentTypeId);
  if (isEmpty(Component)) {
    return null;
  }

  // TODO: Remove this part after all pages are initialized with overview
  // Note: Home mobile variant
  if (isEmpty(props.items) && contentTypeId !== 'recentlyPlayedStationsCollection' && !isEmpty(props.slug)) {
    Component = withGraphqlData(Component);
  }

  return React.createElement(Component, {
    ...props,
    store: storeData,
    tileComponent,
  });
};

export default React.memo(ContentTypeComponent);
